import { useEffect, useState } from "react";
import { useParams, Navigate, Link } from "react-router-dom";
import api from "@/lib/api";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Eyebrow from "@/components/common/Eyebrow";

export default function Page() {
  const { slug } = useParams();
  const [page, setPage] = useState(undefined); // undefined = loading, null = not found
  useEffect(() => {
    setPage(undefined);
    api.get(`/pages/${slug}`).then((r) => setPage(r.data)).catch(() => setPage(null));
  }, [slug]);

  if (page === undefined) return <Box sx={{ py: 16, textAlign: "center", fontSize: 14, color: "text.secondary" }} data-testid="page-loading">Loading…</Box>;
  if (!page) return <Navigate to="/" replace />;

  return (
    <Box sx={{ maxWidth: 720, mx: "auto", px: { xs: 3, lg: 6 }, py: { xs: 10, lg: 14 } }} data-testid={`page-${slug}`}>
      <Eyebrow sx={{ mb: 2 }}>{page.eyebrow}</Eyebrow>
      <Typography className="font-serif-display" sx={{ fontSize: { xs: 36, md: 56 }, lineHeight: 1.05, letterSpacing: "-0.01em", mb: 5 }}>
        {page.title}
      </Typography>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 3, fontSize: 16, lineHeight: 1.7, color: "text.secondary" }}>
        {page.body.map((p, i) => <Typography key={i} variant="body1" color="text.secondary">{p}</Typography>)}
      </Box>
      {page.cta_label && page.cta_to && (
        <Button component={Link} to={page.cta_to} variant="contained" sx={{ mt: 5 }}>{page.cta_label}</Button>
      )}
    </Box>
  );
}
